 cv.TrayView = Marionette.LayoutView.extend({
  template: cv.Templates['tray/view'],

  className : 'tray-overlay',

  bindings : {
  },

  regions : {
    tray_content : '.tray-content',
  },

  events: {
    'click .tray-close' : 'hideTray'
  },

  childEvents: {
    // This callback will be called whenever a child is rendered or emits a `render` event
    'show' : _.bind(function(childView) {
      // Update button Styles
      childView.$('.button-primary').removeClass('-text-dark -text-light');
      childView.$('.button-primary').addClass(cv.idealTextColor(this.$('.button-primary').css('background-color')));

      if(childView.$el.parent().hasClass('tray-content')){
        childView.$el.addClass('tray-content-slide tray-content-hide');
        setTimeout(_.bind(function(){
          childView.$el.removeClass('tray-content-hide');
        }, this), 5);
      }
    }, this),
    'render' : _.bind(function(childView){
      // Update button Styles
      childView.$('.button-primary').removeClass('-text-dark -text-light');
      childView.$('.button-primary').addClass(cv.idealTextColor(this.$('.button-primary').css('background-color')));
    }, this)
  },

  templateHelpers: function () {
    return {
    };
  },

  initialize: function(options){
    this.options = _.extend(this.options, options);
    this.breadcrumbs = [];

    this.listenTo(vent, 'tray:show', this.showTray, this);
    this.listenTo(vent, 'tray:hide', this.hideTray, this);
    this.listenTo(vent, 'tray:lock', this.lockTray, this);
    this.listenTo(vent, 'tray:unlock', this.unlockTray, this);
    this.listenTo(vent, 'tray:add_crumb', this.addCrumb, this);
    this.listenTo(vent, 'tray:refresh_crumbs', this.refreshCrumbs, this);
    this.listenTo(vent, 'tray:reset_crumbs', this.resetCrumbs, this);
    this.listenTo(vent, 'tray:go_wide', function(){
      this.$('.tray').addClass('tray-wide');
    }, this);
    this.listenTo(vent, 'tray:go_normal', function(){
      this.$('.tray').removeClass('tray-wide');
    }, this);

    // Generate the breadcrumb
    this.listenTo(vent, 'project:refresh', function(){
      // This is incredibly hacky, we want to rebind the listener
      // After a refresh event for the breadcrumbs
      setTimeout(_.bind(function(){
        this.listenTo(cv.adminRouter, 'route', function(route, params){
          this.refreshCrumbs();
        }, this);
      }, this), 250);
    }, this);
    this.listenTo(cv.adminRouter, 'route', function(route, params){
      this.refreshCrumbs();
    }, this);

    // Generate the breadcrumb
    this.listenTo(vent, 'team:refresh', function(){
      // This is incredibly hacky, we want to rebind the listener
      // After a refresh event for the breadcrumbs
      setTimeout(_.bind(function(){
        this.listenTo(cv.teamAdminRouter, 'route', function(route, params){
          this.$('.tray-top').html('');
          this.$('.tray-top').prepend(cv.Templates['partials/breadcrumbs']({
            breadcrumbs : this.generateBreadcrumbs()
          }));
        }, this);
      }, this), 250);
    }, this);
    this.listenTo(cv.teamAdminRouter, 'route', function(route, params){
      this.$('.tray-top').html('');
      this.$('.tray-top').prepend(cv.Templates['partials/breadcrumbs']({
        breadcrumbs : this.generateBreadcrumbs()
      }));
    }, this);
  
    console.log('TrayView initialized');
  },

   refreshCrumbs: function(){
     this.$('.tray-top').html('');
     this.$('.tray-top').prepend(cv.Templates['partials/breadcrumbs']({
       breadcrumbs : this.generateBreadcrumbs()
     }));
   },

  resetCrumbs: function(){
    this.breadcrumbs = [];
  },

  addCrumb: function(crumb){
    this.breadcrumbs.push(crumb);
  },

  generateBreadcrumbs: function(){
    var html_arr = [];

    console.log('breadcrumbs', this.breadcrumbs);

    _.each(this.breadcrumbs, function(crumb, index, list){
      html_arr.push('<a href="' + crumb.stub + '">Back to ' + crumb.title + '</a>');
    }, this);

    if(html_arr.length > 1){
      return '<i class="material-icons md-24">chevron_left</i>' + html_arr[html_arr.length - 2];
    }
    if(html_arr.length == 1){
      return '<i class="material-icons md-24">chevron_left</i><a href="dashboard">Back to Dashboard</a>';
    }
    return;
  },

  lockTray: function(){
    this.$('.button').addClass('button-disabled');
  },

  unlockTray: function(){
    this.$('.button').removeClass('button-disabled');
  },

  hideTray: function(e){
    if(!_.isUndefined(e)){
      e.preventDefault();

      // Cut off the admin fragment
      var fragment = Backbone.history.getFragment();
      var base_fragment = fragment.substr(0, fragment.indexOf('/admin'));
      cv.router.navigate(base_fragment);
    }

    vent.trigger('tray:before_hide');

    this.$el.addClass('tray-close-anim');
    setTimeout(_.bind(function(){
      this.$el.removeClass('tray-close-anim');
      this.$el.removeClass('tray-active');
      this.tray_content.reset();
      vent.trigger('tray:after_hide');
    }, this), 500);
  },

  showTray: function(view, options){
    if(!_.isUndefined(options)){
      if(_.has(options, 'hide_close') && options.hide_close == true){
        this.$('.tray-close').remove();
      }
    }

    // Show the view
    this.showChildView('tray_content', view);

    vent.trigger('tray:after_show');
    this.$el.addClass('tray-active');
  },

  onAttach: function(){
  }
});
